export enum DeliveryModalityEnum {
  BuzzDoor = 'Buzz Door',
  CallMe = 'Call Me',
  LeaveOutside = 'Leave Outside',
  PuertaPrincipal = 'Principal Gate',
  Recepcion = 'Reception',
  Otro = 'Other'
}
